import { createApp } from 'vue'
import FloatingVue from 'floating-vue'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'

import App from './App.vue'
import router from './router'
import store from './store'

import './assets/tailwind.css'
import '@/styles/tooltip.css'

// Dyrektywa pól kwotowych: akceptuje przecinek i kropkę jako separator dziesiętny.
// Pola muszą być type="text" inputmode="decimal" (type="number" blokuje przecinek w przeglądarce).
const decimalDirective = {
  mounted(el) {
    const handler = () => {
      let fixed = el.value.replace(/,/g, '.').replace(/[^\d.]/g, '')
      // dopuść tylko jeden separator dziesiętny — usuń kolejne kropki
      const firstDot = fixed.indexOf('.')
      if (firstDot !== -1) {
        fixed = fixed.slice(0, firstDot + 1) + fixed.slice(firstDot + 1).replace(/\./g, '')
      }
      if (fixed !== el.value) {
        el.value = fixed
        el.dispatchEvent(new Event('input')) // odśwież v-model znormalizowaną wartością
      }
    }
    el._decimalHandler = handler
    el.addEventListener('input', handler)
  },
  unmounted(el) {
    el.removeEventListener('input', el._decimalHandler)
  },
}

async function bootstrap() {
  await store.dispatch('initAuth')

  const app = createApp(App)
  app.directive('decimal', decimalDirective)
  app
    .use(store)
    .use(router)
    .use(FloatingVue)
    .use(autoAnimatePlugin)
    .mount('#app')
}

bootstrap()